import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";
import { Timeline } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";
import { useGeometryTypeCheck } from "./useGeometryTypeCheck";
import { useLayerEditable } from "./useLayerEditable";

const LineStringButton: React.FC<IButtonProps> = ({ icon, title = "Draw a line" }) => {
  const { map, drawControl } = useContext(MapContext);
  const isLineStringLayer = useGeometryTypeCheck("LineString");
  const isLayerEditable = useLayerEditable();

  const handleOnClick = () => {
    if (!drawControl.current) return;
    drawControl.current.changeMode("draw_line_string");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "draw_line_string" } as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton
      title={title}
      value="draw_line_string"
      onClick={handleOnClick}
      data-testid="toolbar-linestring-button"
      disabled={!isLineStringLayer || !isLayerEditable}
    >
      {icon || <Timeline />}
    </ToolbarToggleButton>
  );
};

export default LineStringButton;
